import { createUseDevice } from '@empathyco/x-components'
import { breakpoints } from '../device-breakpoints'

export const useDevice = createUseDevice(breakpoints)
